import { useState } from "react";
import { Color } from "three";
import { ChromePicker } from "react-color";
import type { ColorChangeHandler } from "react-color";
import { faEyeDropper } from "@fortawesome/free-solid-svg-icons";

import type { UpdateFuncType } from "./ElementListAdd";

import Dialog from "./Dialog";
import ButtonIcon from "./ButtonIcon";

const ElementListAddColor: React.FC<{
	name: string;
	value: string;
	onChange: UpdateFuncType;
}> = ({ name, value, onChange }) => {
	const [open, setOpen] = useState<boolean>(false);
	const onClose = () => setOpen(false);

	const handleChangeComplete: ColorChangeHandler = ({ hex }, event) =>
		onChange(event, { name, value: hex });

	const color = new Color(value);
	const hsl = color.getHSL({ h: 0, s: 0, l: 0 });
	const colorValue = `#${color.getHexString()}`;

	/*
	To have a color selection tool, user input[type=color]
		<input
			type="color"
			value={colorValue}
			onChange={event => onChange(event, { name, value: event.target.value })}
		/>

	*/
	return (
		<>
			<ButtonIcon
				style={{ backgroundColor: colorValue }}
				inverted={hsl.l < 0.5}
				icon={faEyeDropper}
				onClick={() => setOpen(true)}
			/>
			<Dialog isOpened={open} onClose={onClose} size="fit" title="Pick up a color">
				<ChromePicker
					color={colorValue}
					onChange={handleChangeComplete}
					disableAlpha // opacity is NOT managed by the color, but the material...
				/>
			</Dialog>
		</>
	);
};

export default ElementListAddColor;
